// extracted by mini-css-extract-plugin
export default {"fullPageLoadingLayer":"FullPageLoadingLayer-rebranding-module__fullPageLoadingLayer___bXMvz"};